import React from 'react';
//import { LoadingContext } from './App'; // Adjust the import path based on your project structure
import './LoadingOverlay.css';

const LoadingOverlay = () => {
    //const { isLoading } = useContext(LoadingContext);

    //if (!isLoading) return null;

    return (
        <div className="loading-overlay">
            <div className="loading-content">
                <div className="spinner"></div>
                <p className="loading-text">Cargando contactos...</p>
            </div>
        </div>
    );
};

export { LoadingOverlay };